/* Steffie's -- The Closet
   Reads the member's data (server-rendered metafields via data-* attributes, with a
   localStorage fallback for fit), then renders her fit, per-style sizes, saved colorways,
   and a gift-link she can share. Writes are out of scope here -- favoriting happens on
   the PDP. The referral panel is server-rendered by snippets/steffie-referral-card.liquid
   and driven by assets/steffie-referral.js. */
(function(){
  var root = document.getElementById('steffie-closet');
  if (!root) return;

  function parse(attr, fallback){
    try { return JSON.parse(root.getAttribute(attr) || ''); } catch(e){ return fallback; }
  }
  function el(id){ return document.getElementById(id); }
  function num(str){ if(str==null) return null; var m=(''+str).match(/[0-9]{1,2}(?:[.]5)?/); return m?parseFloat(m[0]):null; }

  /* --- per-style size rules (mirror of the Fit Finder engine) --- */
  var STYLES = [
    { key:'landmark', name:'Landmark', fit:'narrow' },
    { key:'glide',    name:'Glide',    fit:'glide'  },
    { key:'journey',  name:'Journey',  fit:'true'   },
    { key:'explorer', name:'Explorer', fit:'true'   }
  ];
  function sizeFor(fit, ref){
    if (ref == null) return null;
    if (fit === 'narrow') return ref + 0.5;          // runs narrow -> size up 1/2 (regular width)
    if (fit === 'glide')  return Math.floor(ref);    // full sizes only -> round down
    return ref;                                      // true to size
  }

  /* --- 1. Your Fit --- */
  var fit = parse('data-fit', null);
  if (!fit) { try { fit = JSON.parse(localStorage.getItem('steffie_fit_profile') || 'null'); } catch(e){} }

  var fitWrap = el('closet-fit');
  if (fitWrap) {
    if (fit && (fit.size || fit.style)) {
      var sizeLine = fit.size ? ('Size ' + fit.size + (fit.width === 'wide' ? ' (Wide)' : '')) : '-';
      var html = ''
        + '<div class="steffie-fitcard__size">' + (fit.style || 'Your style') + '</div>'
        + '<p class="steffie-fitcard__meta">' + sizeLine + '</p>'
        + (fit.rule ? '<span class="steffie-fitcard__rule">' + fit.rule + '</span>' : '');

      var ref = num(fit.ref) || num(fit.size);
      if (ref != null) {
        html += '<div class="steffie-stylesizes__label">Your size in every style</div>';
        html += '<ul class="steffie-stylesizes">';
        STYLES.forEach(function(s){
          var v = sizeFor(s.fit, ref);
          html += '<li><span>' + s.name + '</span><span>' + (v != null ? v : '-') + '</span></li>';
        });
        html += '</ul>';
      }
      html += '<div style="margin-top:2rem"><a class="steffie-tlink" href="/pages/fit-finder">Retake the Fit Finder &rarr;</a></div>';
      fitWrap.innerHTML = html;
    } else {
      fitWrap.innerHTML = '<div class="steffie-empty">You haven&#39;t found your fit yet. Two minutes, three questions -- then your size follows you everywhere.<br>'
        + '<a class="steffie-tlink" href="/pages/fit-finder">Find my fit &rarr;</a></div>';
    }
  }

  /* --- 2. Saved colorways (server metafield + on-device hearts, merged) --- */
  var faves = parse('data-faves', []) || [];
  try {
    var local = JSON.parse(localStorage.getItem('steffie_closet_favorites') || '[]');
    if (local && local.length) {
      var seen = {}; faves.forEach(function(f){ if(f && f.handle) seen[f.handle] = 1; });
      local.forEach(function(f){ if (f && f.handle && !seen[f.handle]) faves.push(f); });
    }
  } catch(e){}
  var favesWrap = el('closet-faves');
  if (favesWrap) {
    if (faves && faves.length) {
      favesWrap.innerHTML = '<div class="steffie-faves">' + faves.map(function(f){
        var sw = f.swatch ? '<span class="steffie-fave__sw" style="background:' + f.swatch + '"></span>' : '';
        var img = f.image ? '<div class="steffie-fave__img"><img src="' + f.image + '" alt="' + (f.title||'') + '"></div>' : '<div class="steffie-fave__img"></div>';
        return '<a class="steffie-fave" href="/products/' + f.handle + '">' + img
          + '<div class="steffie-fave__name">' + sw + (f.title || f.handle) + '</div></a>';
      }).join('') + '</div>';
    } else {
      favesWrap.innerHTML = '<div class="steffie-empty">No saved colorways yet. Tap the heart on any colorway and it&#39;ll live here.<br>'
        + '<a class="steffie-tlink" href="/collections/all">Browse the collection &rarr;</a></div>';
    }
  }

  /* --- 3. Gift mode: a shareable card encoding her sizes --- */
  var giftWrap = el('closet-gift');
  if (giftWrap) {
    var giftInput = giftWrap.querySelector('[data-gift-link]');
    if (giftInput) {
      var params = [];
      if (fit && fit.handle) params.push('style=' + encodeURIComponent(fit.handle));
      if (fit && fit.size) params.push('size=' + encodeURIComponent(fit.size));
      var name = root.getAttribute('data-first-name');
      if (name) params.push('for=' + encodeURIComponent(name));
      giftInput.value = 'https://steffies.com/pages/fit-finder' + (params.length ? '?' + params.join('&') : '') + '#gift';
    }
  }

  /* --- copy buttons --- */
  root.querySelectorAll('[data-copy]').forEach(function(btn){
    btn.addEventListener('click', function(){
      var sel = btn.getAttribute('data-copy');
      var field = root.querySelector(sel);
      if (!field) return;
      field.select(); field.setSelectionRange(0, 99999);
      var done = function(){ var t = btn.textContent; btn.textContent = 'Copied'; setTimeout(function(){ btn.textContent = t; }, 1600); };
      if (navigator.clipboard) { navigator.clipboard.writeText(field.value).then(done, done); } else { try{ document.execCommand('copy'); }catch(e){} done(); }
    });
  });
})();
